import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  ContactDetails,
  ContactDetailsRequestData,
  ContactHistory,
  ContactHistoryDetails,
  DetailsBox,
  MsisdnConfig,
  RecordHistory
} from './contacts-details.model';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactDetailsService {
  constructor(private http: HttpClient, private activatedRoute: ActivatedRoute) {}

  getGeneralData(contactId: number): Observable<DetailsBox> {
    return this.http.get<DetailsBox>(`/contacts/${contactId}/details-box`);
  }

  getNumberDetailsData(contactId: number): Observable<MsisdnConfig> {
    return this.http.get<MsisdnConfig>(`/contacts/${contactId}/msisdn-config`);
  }

  addPrimaryMsisdn(contactId: string, msisdn: { msisdn: string }): Observable<{ msisdn: string }> {
    return this.http.post<{ msisdn: string }>(`/contacts/${contactId}/msisdns`, msisdn);
  }

  // deleteMsisdn(contactId: string, msisdn: { msisdn: string }): Observable<{ msisdn: string }> {
  //   return this.http.delete<{ msisdn: string }>(`/contacts/${contactId}/msisdns`, msisdn);
  // }

  addNote(noteParam: { recordId: number; note: any }): Observable<{ note: string }> {
    return this.http.post<{ note: string }>(`/contacts/${noteParam.recordId}/note`, { note: noteParam.note });
  }

  isValidNumber(number: string, contactId: number): Observable<any> {
    return this.http.get<any>(`/contacts/${contactId}/valid-msisdn`, {
      params: { msisdn: number, id: contactId.toString() }
    });
  }

  getContactDetails(contactId: number): Observable<ContactDetails> {
    return this.http.get<ContactDetails>(`/contacts/${contactId}`);
  }

  getContactDetailsChangelog(eventId: number): Observable<ContactHistoryDetails[]> {
    return this.http.get<ContactHistoryDetails[]>(`/contacts/changelog/${eventId}`);
  }

  saveContactDetails(contactId: number, contactData: ContactDetailsRequestData): Observable<ContactDetailsRequestData> {
    return this.http.post<ContactDetailsRequestData>(`/contacts/${contactId}`, contactData);
  }

  getAvailableHistoryTypes(contactId: number): Observable<any> {
    return this.http.get<any>(`/contacts/${contactId}/event-types`);
  }

  getContactHistory(data: RecordHistory): Observable<ContactHistory[]> {
    const queryParams = this.getQueryParams(data);

    return this.http.get<ContactHistory[]>(`/contacts/${data.contactId}/events`, {
      params: queryParams
    });
  }

  getQueryParams(data) {
    return Object.entries({
      limit: data.limit.toString(),
      pointId: data.eventId,
      searchDirection: data.searchDirection,
      type: data.type
    })
      .filter(([_, value]) => !!value)
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
  }

  getContactDetailsReport(recordData: { id: number; timezoneOffsetMinutes: number }): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf;charset=utf-8');

    return this.http.get<any>(
      `${
        document.location.origin === environment.CHANNELS_URL
          ? environment.BACKEND_CHANNELS_URL
          : environment.BASE_BACKEND_URL
      }/contacts/${recordData.id}/history/pdf?timezoneOffsetMinutes=${recordData.timezoneOffsetMinutes}`,
      { headers: headers, responseType: 'blob' as 'json' }
    );
  }
}
